export class TokenStorage {
  private static readonly ACCESS_TOKEN_KEY = 'access';
  private static readonly REFRESH_TOKEN_KEY = 'refresh';

  static setTokens(accessToken?: string, refreshToken?: string) {
      if (accessToken) {
          localStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
      }
      if (refreshToken) {
          localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);
      }
  }

  static getAccessToken(): string | null {
      const token = localStorage.getItem(this.ACCESS_TOKEN_KEY);
      return token;
  }

  static getRefreshToken(): string | null {
      const token = localStorage.getItem(this.REFRESH_TOKEN_KEY);
      return token;
  }

  static removeTokens() {
      localStorage.removeItem(this.ACCESS_TOKEN_KEY);
      localStorage.removeItem(this.REFRESH_TOKEN_KEY);
  }

  static hasTokens(): boolean {
      const hasAccess = !!this.getAccessToken();
      const hasRefresh = !!this.getRefreshToken();
      return hasAccess && hasRefresh;
  }
}